// Screen `option-sets` — owner: S4. Settings › Data › Option sets; `?set=<key>` opens one set.
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { OptionSetsPage } from '../../../features/data-model/OptionSetsPage';

export const Route = createFileRoute('/_settings/settings/option-sets')({
  validateSearch: z.object({ set: z.string().max(63).optional().catch(undefined) }),
  component: OptionSetsRoute,
});

function OptionSetsRoute() {
  const { set } = Route.useSearch();
  return <OptionSetsPage initial={set} />;
}
